import React from 'react';
import { Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import serviceList from 'data/feature/serviceList';

const Services = () => {
  return (
    <section className="wn-section" id="services">
      <Container>
        <div className="wn-fade-in">
          <div className="wn-section-label">
            <span className="label-dot" />
            What We Do
          </div>
          <h2 className="wn-section-title">
            The build work that turns a legacy operation into a modern one
          </h2>
          <p className="wn-section-subtitle">
            We do not sell isolated tools. We design the operating system around
            them: AI workflows, ecommerce infrastructure, product data, team
            adoption, and the management cadence that keeps it producing.
          </p>
        </div>

        <div className="wn-services-grid">
          {serviceList.map((service, i) => (
            <div
              key={i}
              className={`wn-service-card wn-fade-in wn-fade-in-delay-${i + 1}`}
            >
              <div className={`service-icon ${service.iconClass || ''}`}>
                <FontAwesomeIcon icon={service.media.icon} />
              </div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              {service.features && (
                <ul className="service-features">
                  {service.features.map((f, j) => (
                    <li key={j}>{f}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Services;
